import React, { memo } from "react";
import { PrePpWlAlterationsOrExtensionsToExistingHouseType } from "./PrePpWlAlterationsOrExtensionsToExistingHouseType";
import { useForm } from "../hooks/formContext";
import { BuildNewDwellingsType } from "./BuildNewDwellingsType";
import { OtherType } from "./OtherType";
import { RetailOfficeIndustrialDevelopmentType } from "./RetailOfficeIndustrialDevelopmentType";
import { Button } from "govuk-react";
import { PrePpWlDescriptionOfDevelopmentDevelopmentTypes } from "@shared/prePublicPortalWestLindsay/contracts/IPrePpWlForm";
import { PrePpWlFormComponentStepProps } from "../PrePublicPortalWlForm";
import Box from "@mui/material/Box";

export const PrePpWlTypeOfDevelopmentStep = memo((props: PrePpWlFormComponentStepProps) => {
    const { next } = props;
    const { formState, previous } = useForm();
    const { typeOfDevelopment } = formState;

    const getTypeContent = () => {
        switch (typeOfDevelopment.value) {
            case PrePpWlDescriptionOfDevelopmentDevelopmentTypes.ALTERATIONS_EXTENSIONS:
                return <PrePpWlAlterationsOrExtensionsToExistingHouseType />;
            case PrePpWlDescriptionOfDevelopmentDevelopmentTypes.NEW_DWELLINGS:
                return <BuildNewDwellingsType />;
            case PrePpWlDescriptionOfDevelopmentDevelopmentTypes.RETAIL_OFFICE_INDUSTRIAL:
                return <RetailOfficeIndustrialDevelopmentType />;
            case PrePpWlDescriptionOfDevelopmentDevelopmentTypes.OTHER:
                return <OtherType />;
            default:
                return null;
        }
    };

    return (
        <>
            {getTypeContent()}
            <Box display="flex" justifyContent="space-between">
                <Button onClick={previous}>Previous</Button>
                <Button onClick={next}>Next</Button>
            </Box>
        </>
    );
});
